import {
  REQUEST_CAMPAIGN_CATEGORY_LIST_WITH_CHILDREN
} from './mutation-types'

export default {
  [REQUEST_CAMPAIGN_CATEGORY_LIST_WITH_CHILDREN](state, receivedData) {
    state.campaignCategoryListWithChildren = receivedData
  },
}